import ChooseInterviewTypeModal, {
  ChooseInterviewTypeModalProps,
} from './ChooseInterviewTypeModal.component';

export type ChooseInterviewTypeModalType = ChooseInterviewTypeModalProps;

export default ChooseInterviewTypeModal;
